import { gql } from '@apollo/client';

export default gql`
  query priceBookProducts {
    priceBookProducts {
      id
      price
      showInStore
      overPrice
      productId
      product {
        id
        active
        name
        price
        description
        sku
        defaultSubscriptionRetainer
        productCategories {
          id
          name
        }
        featuredImage
        productRenewalInterval {
          id
          name
        }
        productFeatures {
          id
          text
        }
        productImages {
          id
          imageUrl
        }
        productType
        planSubscription {
          id
          name
        }
        planProducts {
          id
          overridePrice
          price
        }
      }
    }
  }
`;
